<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <h2>Terms and Conditions</h2>
        <button class="close-btn" @click="$emit('cancel')">×</button>
      </div>

      <div class="modal-body">
        <div class="content-wrapper">
        <div class="content">
          <h3 class="main-title">CW HOME DEPOT'S LOYALTY REWARDS PROGRAM</h3>
          <h4 class="sub-title">TERMS & CONDITIONS</h4>

          <section>
            <h5>WHO ARE QUALIFIED TO JOIN?</h5>
            <p>The applicant must be at least 18 years old and above, a Filipino Citizen with valid government-issued identification cards.</p>
          </section>

          <section>
            <h5>HOW TO APPLY?</h5>
            <p>There are 3 Ways to apply for Loyalty Rewards Membership:</p>
            <ol>
              <li>Download CW Home Depot's Loyalty Rewards Program mobile app on Apple Store (iOS) or Google Play Store (Android).</li>
              <li>Visit any CW Home Depot store and apply at the customer service counter.</li>
              <li>Register online through the official CW Home Depot website.</li>
            </ol>
          </section>
          
           <section>
            <h5>REGISTRATION OF MEMBERSHIP:</h5>
            <h3>Sign-Up:</h3>
            <ul>
              <li>Open the CW Home Depot Loyalty Rewards Program App.</li>
              <li>Complete the membership information sheet and submit the required information based on membership type.</li>
            </ul>

            <h3>Verification:</h3>
            <ul>
              <li>After submitting your information, the app will send an OTP (One-Time Password) to your registered mobile number and email for verification.</li>
              <li><b>Retail Membership: </b> All applications are initially registered as Retail by default.</li>
              <li><b>Professional Membership: </b> To apply for a professional membership, tick the "Professional" box. The app will notify you when your membership has been upgraded after verification.</li>
            </ul>

            <h3>Approval Process:</h3>
            <ul>
              <li>Retail membership does not require approval.</li>
              <li>Professional and Corporate-Retail applications need approval before processing.</li>
              <li>CW Home Depot's backend support will handle the verification of IDs.</li>
            </ul>

            <h3>Access and Earning Points:</h3>
            <ul>
              <li>After account verification, members can log in to the app and start earning loyalty points.</li>
              <li>Members can log in using Face Recognition for added convenience.</li>
            </ul>
          </section>

          <section>
            <h5>REQUIREMENTS OF MEMBERSHIP:</h5>
            <p><i>A. Retail</i></p>
            <ul>
              <li>1 valid government-issued identification card</li>
            </ul>

            <p><i>B. Professional (Exclusive for Architects, Builders, Contractors, Interior Designers, and Engineers)</i></p>
            <ul>
              <li>A valid Profession Regulation Commission (PRC) identification card (approval is based on pre-selected professions related to Architecture, Engineering (Civil, Mechanical, Electrical, Electronics and Communications), Construction, and Interior Design) </li>
            </ul>

            <p><i>C. Corporate-Retail</i></p>
            <ul>
              <li>Sole Proprietorship</li>
                - Certificate of DTI Registration <br/>
                - 1 valid government-issued identification card <br/><br/>  

              <li>Partnership/Corporation</li>
                - Securities and Exchange Commission (SEC) Certification of Registration/ Partnership <br/>
                - Articles of Partnership <br/>
                - Updated General Information Sheet <br/>
                - Board Resolution/ Secretary Certificate authorizing the applicant to apply in behalf of the company <br/><br/>

              <li>Cooperative/Non-Profit Organization</li>
                - Securities and Exchange Commission (SEC)/Cooperative Development Authority (CDA) Certificate Registration <br/>
                - Updated General Information Sheet <br/>
                - Board Resolution/ Secretary Certificate authorizing the applicant to apply in behalf of the company <br/><br/>  
            </ul>
          </section>

          <section>
            <h5>MEMBERSHIP/ POINTS VALIDITY AND EXPIRY</h5>
            <h3>Membership Validity:</h3>
            <ul>
              <li>The Loyalty Membership itself has lifetime validity.</li>
            </ul>

            <h3>Points Validity:</h3>
            <ul>
              <li>Loyalty points are valid for 1 year from the date of the most recent purchase.</li>
              <li>Points will expire if <b>no purchase</b> is made within a <b>1-year period</b>.</li>
            </ul>

            <h3>Inactive Membership:</h3>
            <ul>
              <li>If no purchase is made within <b>two (2) years</b>, the loyalty membership will be tagged as <b>inactive</b>.</li>
            </ul>

            <h3>Points Credit Timing:</h3>
            <ul>
              <li><b>Walk-in transactions:</b>   Points will be credited on the following day after the transaction.</li>
              <li><b>Delivery transactions:</b>  Points will be credited on the day the items are received. </li>
            </ul>
          </section>

          <section>
            <h5>HOW TO CHECK POINTS</h5>
             <ul>
              <li>Members can check their loyalty points through the CW Home Depot Loyalty Rewards Program App.</li>
            </ul>
          </section>

          <section>
            <h5>HOW TO EARN POINTS:</h5>
            <h3>Points Earning:</h3>
            <ul>
              <li>For every <b>P400.00</b> worth of purchase, a member earns <b>1 point</b>.</li>
              <li>The <b>Loyalty Membership/QR Code</b> must be presented at the <b>cashier's counter before payment</b>.</li>
              <li>Only fully paid and fully delivered invoices are qualified to earn points.</li>
            </ul>

            <h3>Where to Earn Points:</h3>
            <ul>
              <li>Points can be earned at <b>any CW Home Depot branch</b>.</li>
              <li>The points credited are based on the total net amount paid by the member, after discounts or adjustments.</li>
              <li><b>No QR Code, No Points - </b>If the QR code is not presented, no points will be credited.</li>
              <li><b>No manual crediting</b> of points will be allowed.</li>
              <li><b>Membership is non-transferable at all times</b>. It is valid only for use by the person whose name is specified on the loyalty account (for <b>Retail & Professional types</b>). For <b>Corporate-type memberships</b>, only the <b>authorized representatives</b> listed on the application form will be allowed to earn points, unless an <b>authorization letter</b> is presented  </li>
            </ul>

            <h3>Valid Payment Methods for Earning Points:</h3>
            <p>Points can be earned using the following payment methods:</p>
             <ul>
              <span>&#x2714;<b> Cash</b></span><br/>
              <span>&#x2714;<b> G-Cash</b></span><br/>
              <span>&#x2714;<b> Bank-to-Bank Transfer</b></span><br/>
              <span>&#x2714;<b> Dated Checks and Post-Dated Checks </b>(upon clearing)</span><br/>
              <span>&#x2714;<b> Customer Deposit </b>(upon redemption)</span><br/>
              <span>&#x2714;<b> BIR 2307 </b></span><br/>
              <span>&#x2714;<b> Debit Cards </b></span><br/>
              <span>&#x2714;<b> Credit Cards </b>(both straight and installment)</span><br/>
            </ul>

            <h3>Gift Certificates and Returns:</h3>
            <ul>
              <li>Points can be earned when purchasing <b>gift certificates</b>. However, points will not be credited if the gift certificates are obtained through <b>promotional activities</b> or <b>X-deals</b>.</li>
              <li><b>Credit Memos</b> will not earn points, as the item returned has already earned points.</li>
              <li><b>Sample item (AR Sample), Redemption of Loyalty Points</b> will also not earn points.</li>
              <li><b>No points</b> will be earned for <b>COD transactions</b>.</li>
            </ul>

            <h3>Point Transfer Restrictions:</h3>
            <ul>
              <li><b>No gift giving of points</b> is allowed. Points are non-transferable between members.</li>
            </ul>
          </section>

          <section>
          <h5>REDEMPTION OF POINTS</h5>

          <h3>Points to Currency Conversion:</h3>
          <ul>
            <li>Earned loyalty points can be used to <b>purchase items in-store</b>.</li>
            <li><b>1 point</b> is equivalent to <b>PHP 1.00</b>.</li>
          </ul>

          <h3>Non-Cash Redemption:</h3>
          <ul>
            <li><b> Loyalty points are not convertible to cash.</b> They can only be used for purchasing items in CW Home Depot stores.</li>
          </ul>

          <h3>Redemption Requirements:</h3>
          <ul>
            <li>Member must present their <b>QR code</b> when redeeming points.</li>
            <li>They must have <b>enough points</b> to redeem the item they wish to purchase. Only <b>whole numbers</b> will be accepted for redemption (no fractions).  </li>
          </ul>

          <h3>OTP Verification:</h3>
          <ul>
            <li>Upon redemption, a <b>One-Time-Pin (OTP)</b> will be sent to the member's registered <b>mobile number</b> for verification.</li>
          </ul>
          </section>

          <section>
          <h5>UPDATE OF MEMBERSHIP INFORMATION</h5>

          <h3>Updating Membership Information:</h3>
          <ul>
            <li>A member can <b>update their membership</b> through the <b>CW Home Depot Loyalty</b></li>
            <li>Rewards Program App. Members are entitled to update their personal information, such as: </li>
             <ul>
              <li>Change of <b>address</b></li>
              <li><b>Nickname</b></li>
              <li>Other relevant details</li>
            </ul>
          </ul>

          <h3>Changing Surname:</h3>
          <ul>
            <li><b>Changing of surname</b> must be requested directly to the <b>CW Home Depot headquarters</b> for <b>further verification</b>.</li>
          </ul>

          <h3>Membership Type Changes:</h3>
          <ul>
            <li>Members who wish to update their membership type from <b>Individual</b> to <b>Professional</b> need to: </li>
            <ul>
              <li><b>Consume all points</b> in their current membership.</li>
              <li>Afterward, they can re-apply for the membership type of their choice provided that necessary and complete requirements are submitted.</li>
            </ul>
          </ul>
          <p>GENERAL CONDITIONS</p>
          <ol>
            <li>The terms and conditions stated in this form will serve as the basis, guidelines, and usage of CW Home Depot's Loyalty Rewards Program. These also define the rights and obligations of the member.</li>
            <li>Members are the subject to these guidelines and are deemed to have accepted the terms and conditions upon confirmation of membership application form.</li>
            <li>The loyalty membership is not transferable at any circumstance and is valid for use by the member whose name appears on the loyalty account.</li>
            <li>If a member applies for a second account under the same name, but different phone number, the old membership will still be active. Transaction records will be credited to the QR code present by the member.</li>
            <li>Membership has a lifetime validity. Points are valid for one (1) year from the time of approval of membership, provided, the member has made a purchase within the said period. If no purchase has been made within two (2) years, loyalty membership will be tagged as inactive.</li>
            <li>Membership will be terminated automatically with all rights and privileges upon the death of the member.</li>
            <li>By redeeming of points, the member releases CW Home Depot from any and all liability regarding the use and privileges of CW Home Depot's Loyalty Rewards Program. </li>
            <li>CW Home Depot may use the information acquired during membership processing for administrative and marketing purposes.</li>
            <li>CW Home Depot shall use all reasonable endeavors to provide members with accurate and timely information regarding CW Home Depot's Loyalty Rewards Program including any changes thereof; however, CW Home Depot shall not be liable in any way for failure to do so.</li>
            <li> CW Home Depot reserves the right at all times in its sole discretion:
              <ul>
                a. &nbsp; To make any changes or whatsoever to these Terms and Conditions including the rules and guidelines in the Loyalty Rewards such changes to the Terms and Conditions shall be published at least once through its website and/or its social media platforms. <br/>
                b. &nbsp; To withdraw, cancel, withhold, substitute, deny access to, or use of, or in any way change any of the rewards or privileges previously advertised or offered to any member, at any time, with electronic notice (if electronic mail is provided) or through SMS. CW Home Depot shall not be liable to any loss or damage experienced by the member resulting from such withdrawal, cancellation, variation or change on the terms and conditions. <br/>
                c. &nbsp; To terminate or materially alter CW Home Depot Loyalty Program and / or revoke the membership or to utilize any points or privilege. <br/>  
                d. &nbsp; Breach of any of the Terms and Conditions, whether intentional or otherwise may result in termination of membership and cancellation of rewards or privilege, and shall affect its eligibility for future or further participation CW Home Depot's Loyalty Rewards Program. Thus, CW Home Depot shall in no way be liable for any earned or accrued points of a terminated Loyalty Member. <br/> 
              </ul>
            </li>
            <li>The following acts are considered Breach of Terms and Conditions by a member: 
              <ul>
                a. &nbsp; Any fraudulent act which is likely to be detrimental to the interest of CW Home Depot. <br/>
                b. &nbsp; Any misinformation or misrepresentation made to CW Home Depot. <br/>
                c. &nbsp; Any act, in the careful and reasonable opinion of CW Home Depot, tantamount to breach of these Terms and Conditions. <br/>  
                d. &nbsp; To make adjustments on accumulated transactions as it sees fit including, but not limited to, deduction of number of accumulated transactions arising from returned goods or service purchased. <br/>
                e. &nbsp; The Terms, Conditions, and Guidelines cannot be superseded or changed except by CW Home Depot. <br/>  
              </ul>
            </li>
            <li>These Terms and Conditions shall be governed by the laws of the Republic of the Philippines.</li>
            <li> CW Home Depot will resolve all questions or disputes regarding eligibility for membership in CW Home. Depot's Loyalty Rewards Program or eligibility for redemption of rewards or privileges at its sole discretion.</li>
            <li> Failure of CW Home Depot to enforce a particular Term or Condition or Guideline does not constitute a waiver of that Terms or Conditions or Guidelines.</li>
            <li> Member is personally liable for any and at costs, charges, claims or liabilities including duties, taxes and fees from third parties, government and non-government entities of whatever nature arising from the use of any privilege, as provided by CW Home Depot's Loyalty Rewards Program and the redemption or use of any points or privilege.</li>
          </ol>
          </section>

          <section>
          <h3>PRIVACY POLICY</h3>
          <p>
            CW Home Depot does not automatically collect your personal information when you use CW Home Depot's Loyalty 
            Rewards Program. Protecting any personal information, such as your name, address, email address or phone 
            number that you provide to us is of the utmost importance to CW Home Depot and its subsidiaries, divisions, 
            brands, branches and all its affiliates. 
          </p>
          <p>
            As a result, we have prepared this Privacy Policy to let you know about the manner in which we collect, use, 
            disclose and otherwise manage the personal information you entrust to us based on the details you've provided 
            through CW Home Depot's Loyalty Rewards Program App and www.cwhomedepot.com.  
          </p>
          <p>
            When you provide personal information on the above-mentioned platforms, you are consenting to the manner in 
            which CW Home Depot will collect, use, disclose and otherwise manage the personal information of our 
            consumers, as set out below. 
          </p>

          <p>CW Home Depot may collect personal information that you provide us when you: </p>
          <ol>
            <li>Request certain information about our products and services;</li>
            <li>Request a quote and/or purchase one of our products or services;</li>
            <li>Request warranty or product repair services; </li>
            <li>Inquire about our Leasing policies; </li>
            <li>Provide us with feedback, comments or suggestions. </li>
          </ol>

          <p>
            The information you provided thru CW Home Depot's Loyalty Rewards Program will not be shared, sold, or 
            disclosed to third parties in any form, for any purposes, at any time, unless with your express consent or unless 
            required by law or judicial order. If you feel that your information has been used without your consent, please inform 
            us and we will remove any private information collected from our database, send us an email at 
            info@cwhomedepot.com 
          </p>
          </section>

          <section>
          <h3>DISCLAMERS</h3>
          <p>
            All information and merchandise on Loyalty app and website are provided by CW Home Depot on an "as is" basis, 
            without warranties of any kind, either express or implied, including without limitation warranties of merchantability or 
            fitness for a particular purpose, security, accuracy, and non-infringement.  
            CW Home Depot may add or revise the information in Loyalty app and website, and shall not be liable for any 
            errors or omissions in the content, or for any reliance placed on information contained. You assume all risks 
            associated with your use of Loyalty app and website, including damage to your device, computer or other 
            equipment.
          </p>
          <p>
            CW Home Depot does not warrant that Loyalty app and website, its servers, or e-mail sent from this app/ site are 
            free from viruses or other harmful effects.  
          </p>
          </section>

          <section>
          <h3>COOKIES</h3>
          <p>
            CW Home Depot Group use Cookies to obtain information about the preferences of our Visitors and the services 
            they select. 
          </p>
          <p>
           CW Home Depot also use Cookies for security purposes to protect our Authorized Customers.  
          </p>
          </section>

          <section>
          <h3>USAGE</h3>
          <p>
            By using CW Home Depot's Loyalty App and website or ordering any merchandise from us, you acknowledge that 
            you have read and understand these policies and agree to be bound by them. We may change or modify these 
            policies from time to time so please review them to ensure your acceptance. If you do not agree to these policies, 
            you are not authorized to use these platforms.  
          </p>
          </section>

          <section>
          <h3>THIRD PARTY SITES</h3>
          <p>
            Our App or Website may include links to the websites of our business partners, suppliers, tenants and advertisers. 
            Except as provided herein, we will not provide any of your personal information to these third parties without your 
            prior consent. CW Home Depot provides links to third party websites as a convenience to the user. The inclusion of 
            any link does not imply CW Home Depot's endorsement of any other company, its websites, or its products and/or 
            services. These linked websites have separate and independent privacy policies, which we recommend that you 
            read diligently. We have no control over such websites and therefore have no responsibility or liability for the 
            manner in which the organizations that operate such linked websites may collect, use or disclose and otherwise 
            treat your personal information.  
          </p>
          </section>

          <section>
          <h3>COPYRIGHT</h3>
          <p>
            All content and materials on CW Home Depot's Loyalty App and website, including without limitation this app / site's 
            layout, organization and design, are protected by copyright laws. No information on these platforms may be 
            reproduced without the prior written consent of CW Home Depot by CW Marketing and Development Corporation.  
          </p>
          </section>

          <section>
          <h3>FILING OF COMPLAINT</h3>
          <p>
            A member may file a complaint should his or her right to privacy be violated, in accordance with the Data Privacy 
            Act of 2012 and its Implementing Rules and Regulations. 
          </p>
          </section>

          <section>
          <h3>INQUIRIES</h3>
          <p>
            For comments, suggestions, or inquiries, you may reach CW Home Depot through these contact details:  
          </p>
          <p>
            CW Home Depot- Customer Care Hot line: <b>8706-HOME (4663)</b>
          </p>
          <p>
            Viber numbers: 0917-5924513/0922-8138132
          </p>
          <p>
            Email: info@cwhomedepot.com 
          </p>
          </section>
        </div>
        </div>
      </div>


      <div class="modal-footer">
        <button class="cancel-btn" @click="$emit('cancel')">Cancel</button>
        <button class="agree-btn" @click="$emit('agree')">I Agree</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsAndConditions",
  props: {
    logo: {
      type: String,
      default: '/img/brand/bxi-clp-blue-logo.png'
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-container {
  background: #fff;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
}

/* Header */
.modal-header {
  position: sticky;
  top: 0;
  background: #fff;
  padding: 1rem;
  font-weight: bold;
  font-size: 1.2rem;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
}

.modal-body {
  overflow-y: auto;
  padding: 1rem 1.5rem;
  flex-grow: 1;
  background-image: url('../../../../images/login_bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgba(255, 255, 255, 0.50);
  background-blend-mode: lighten;
}


.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.main-title {
  text-align: center;
  color: #f26522 !important;
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.sub-title {
  text-align: center;
  color: #333333 ;
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
}

.modal-body h5 {
  color: #f26522;
  font-weight: bold;
  margin-top: 1rem;
}

.modal-body h3 {
  color: #333333 ;
  font-weight: bold;
  font-size: 15px;
  margin-top: 1rem;
}

.modal-body p,
.modal-body ol,
.modal-body ul {
  margin: 0.5rem 1rem;
  color: #333333 ;
}

/* Footer */
.modal-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 1rem;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.cancel-btn,
.agree-btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-btn {
  background: #e0e0e0;
}

.agree-btn {
  background: #f26522;
  color: #fff;
}
</style>
